"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _SettingsActions = require("../actions/SettingsActions");

var _requestStatusSelectors = require("../selectors/requestStatusSelectors");

var _SettingsAPI = _interopRequireDefault(require("../api/SettingsAPI"));

var fetchSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _SettingsAPI.default.get,
  initiatingActionType: _SettingsActions.SettingsActionTypes.FETCH_SETTINGS,
  requestStatusSelector: _requestStatusSelectors.getFetchSettingsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _SettingsActions.FetchSettings
}));
var fetchIP = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _SettingsAPI.default.getIP,
  initiatingActionType: _SettingsActions.SettingsActionTypes.FETCH_IP,
  requestStatusSelector: _requestStatusSelectors.getFetchIPRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _SettingsActions.FetchIP
}));

var _default = (0, _reduxObservable.combineEpics)(fetchSettings, fetchIP);

exports.default = _default;
module.exports = exports.default;